"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
    TEAM_IDENTIFIER_FOR_PARTNER: "partner_popstudy",
    // collection paths
    COLLECTION_PATH_DAY_PLAN: "popstudy_day_plans",
    COLLECTION_PATH_DAY_PLAN_MODULE: "day_plan_modules",
    COLLECTION_PATH_DELETED_DAY_PLAN_MODULE: "deleted_day_plan_modules",
    COLLECTION_PATH_STUDY_SESSION: "popstudy_study_sessions",
    COLLECTION_PATH_USER_RESPONSE: "popstudy_user_responses",
    COLLECTION_PATH_APPLICATION_PROFILE: "popstudy_profiles",
    COLLECTION_PATH_INCLUDED_MODULE_INFO: "included_modules",
    COLLECTION_PATH_APPLICATION_SETTING: "popstudy_settings",
    COLLECTION_PATH_STATS: "popstudy_stats",
    COLLECTION_PATH_MODULE_STATS: "module_stats",
    COLLECTION_PATH_CONCEPT_STATS: "concept_stats",
    COLLECTION_PATH_CARD_STATS: "card_stats",
    COLLECTION_PATH_DAILY_MODULE_STATS: "daily_module_stats",
    COLLECTION_PATH_MONTHLY_MODULE_STATS: "monthly_module_stats",
    COLLECTION_PATH_YEARLY_MODULE_STATS: "yearly_module_stats",
    COLLECTION_PATH_DAILY_OVERALL_STATS: "daily_overall_stats",
    COLLECTION_PATH_MONTHLY_OVERALL_STATS: "monthly_overall_stats",
    COLLECTION_PATH_YEARLY_OVERALL_STATS: "yearly_overall_stats",
    COLLECTION_PATH_STUDY_ORDER_PROGRESS: "study_order_progress",
    COLLECTION_PATH_PRONUNCIATION_SESSION: "pronunciation_sessions",
    COLLECTION_PATH_PRONUNCIATION_SESSION_RESULTS: "results",
    COLLECTION_PATH_FCM_TOKENS: "popstudy_fcm_tokens",
    COLLECTION_PATH_DAY_PLAN_GENERATION_TASK: "day_plan_gen_tasks",
    COLLECTION_PATH_DAY_PLAN_MODULE_GENERATION_TASK: "day_plan_module_gen_tasks"
};
